import {
    GET_SUPPORT_TICKETS,
    SUPPORT_TICKETS_CHANGED,
    SET_LOADING,
    SET_ERROR
} from "../constants/support.constants";

export const getSupportTickets = () => ({ type: GET_SUPPORT_TICKETS });
export const supportTicketsChanged = tickets => ({ type: SUPPORT_TICKETS_CHANGED, tickets });
export const setLoading = loading => ({ type: SET_LOADING, loading });
export const setError = error => ({ type: SET_ERROR, error });
